import brandingConfig from "../../branding.json";

// const API_BASE_URL = "http://localhost:8000";
// const API_BASE_URL = "https://apis.docreader.webnerserver.com";
const API_BASE_URL = "https://apis.docreader.winsurtech.com";
export const BRANDING = {
  shortName: brandingConfig.shortName,
  companyName: brandingConfig.companyName,
  assistantName: brandingConfig.assistantName,
  teamSignature: brandingConfig.teamSignature,
  footerYear: brandingConfig.footerYear,
};

export default API_BASE_URL;
